export type ToastType = 'success' | 'error' | 'info';

export const toastTitleRecord: Record<ToastType, string> = {
  success: 'actions.toast.successfully',
  error: 'actions.toast.failed',
  info: 'actions.toast.info',
};

export const toastIconRecord: Partial<Record<ToastType, string>> = {
  success: 'possible-fill',
  error: 'not-possible-fill',
};
